
import $ from 'jquery';
import plugin from '@core/plugins/lib';

export const ELEMENT_SELECTOR = '[data-button-count]';
export const PLUGIN_NAME = 'ButtonCount';

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(/* webpackChunkName: "button-count" */ './button-count'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/components/button-count/index.js